import React from "react";
import "./boxcontainer.scss";
import star from "./star.svg";
import group from "./group.svg";
import downloads from "./downloads.svg";
import like from "./like.svg";

const BoxContainer = () => {
  return (
    <div className="box-container">
      <div className="containers">
        <div className="box">
          <img src={group} alt="" />
          <h3>5100</h3>
          <p>Users</p>
        </div>
        <div className="box">
          <img src={like} alt="" />
          <h3>5100</h3>
          <p>Happy Clients</p>
        </div>
        <div className="box">
          <img src={star} alt="" />
          <h3>5100</h3>
          <p>Reviews</p>
        </div>
        <div className="box">
          <img src={downloads} alt="" />
          <h3>5100</h3>
          <p>Downloads</p>
        </div>
      </div>
    </div>
  );
};

export default BoxContainer;
